import { useMemo } from 'react';
import { PipelineView } from '../types/PipelineView';
import { IssuanceMonitorTopPanel } from './IssuanceMonitorTopPanel';
import { Tab, PipelineTabs } from './PipelineTabs';
import { IssuanceMonitorTab } from '../types/PipelineTabTypes';
import { hasIOIsAccess } from '../../../utils/amr-pipeline.utils';

interface IssuanceMonitorLayoutProps {
    tab: IssuanceMonitorTab;
    setTab: (tab: IssuanceMonitorTab) => void;
    viewMode: PipelineView;
    children: React.ReactNode;
}

const Tabs = [
    { title: 'Deals', tab: IssuanceMonitorTab.Deals },
    { title: 'Dashboard', tab: IssuanceMonitorTab.Dashboard },
    { title: 'Arranger Pipeline', tab: IssuanceMonitorTab.ArrangerPipeline },
    { title: 'IOIs', tab: IssuanceMonitorTab.IOIs },
];

export const IssuanceMonitorLayout = ({ tab, setTab, viewMode, children }: IssuanceMonitorLayoutProps) => {
    const ioisAccess = hasIOIsAccess();
    const accessibleTabs = useMemo(() => Tabs.filter(({ tab }) => ioisAccess ? true : tab !== IssuanceMonitorTab.IOIs), [ioisAccess]);

    return (
        <>
            <div className="sub-header sub-header-pipeline sub-header-head">
                <div className="sub-header-row flex-row type04">
                    <PipelineTabs className="tabs-large" value={tab} onChange={setTab}>
                        {accessibleTabs.map(({ title, tab }) => (
                            <Tab
                                title={title}
                                key={tab}
                                value={tab}
                            />
                        ))}
                    </PipelineTabs>

                    {tab !== IssuanceMonitorTab.Dashboard && (
                        <IssuanceMonitorTopPanel tab={tab} viewMode={viewMode} />
                    )}
                </div>
            </div>
            {children}
        </>
    );
};
